import { $fetch } from '@/boot/fetch'
import { replacePathTokens } from '@/utils/routes.util'

const ENDPOINT = '/retailers/{{retailerId}}/pickupLocations'

export default {
  /**
   * Add a pickup location for the retailer
   * @param {String} retailerId - The retailer ID
   * @param {Object} body - Pickup location body { addressId, hours }
   * @return {Promise}
   */
  addSingle(retailerId, body) {
    return $fetch.peg(replacePathTokens(ENDPOINT, { retailerId }), {
      method: 'POST',
      body,
    })
  },

  /**
   * Update a pickup location for the retailer
   * @param {String} retailerId - The retailer ID
   * @param {String} locationId - The pickup location ID
   * @param {Object} body - Pickup location body { addressId, hours }
   * @return {Promise}
   */
  updateSingle(retailerId, locationId, body) {
    return $fetch.peg(replacePathTokens(ENDPOINT, { retailerId }) + `/${locationId}`, {
      method: 'PUT',
      body,
    })
  },

  /**
   * Delete a pickup location for the retailer
   * @param {String} retailerId - The retailer ID
   * @param {String} locationId - The pickup location ID
   * @return {Promise}
   */
  deleteSingle(retailerId, locationId) {
    return $fetch.peg(replacePathTokens(ENDPOINT, { retailerId }) + `/${locationId}`, {
      method: 'DELETE',
    })
  },
}
